"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const api_1 = require("@/api");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
function default_1() {
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const roomImg = (0, react_redux_1.useSelector)((state) => state.roomData.img_url);
    const hasNoMainImage = !roomImg;
    const mainImgSrc = (0, functions_1.getCdnUrl)(roomImg);
    const dispatch = (0, react_redux_1.useDispatch)();
    const postMainImage = (compressedImgArr) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('image', compressedImgArr[0]);
        formData.append('thumbnail', compressedImgArr[1]);
        yield (0, api_1.postFormData)(`/api/v1/room/${roomId}/image`, formData)
            .then(res => { var _a, _b; return dispatch((0, roomCreateStore_1.setRoomImage)((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.image)); })
            .catch(err => alert((0, errors_1.commonErrorMsg)(err.response.status)))
            .finally(() => setUploading(false));
    });
    const uploadMainImage = (files) => {
        const imageFile = files[0];
        setUploading(true);
        const compressMainImg = new Promise((resolve, reject) => {
            (0, functions_1.compressImageFile)({
                imageFile,
                maxWidth: 1500,
                quality: 0.7,
                onCompressSuccess: resolve,
                onCompressError: () => {
                    reject();
                    setUploading(false);
                },
            });
        });
        const compressThumbnailImg = new Promise((resolve, reject) => {
            (0, functions_1.compressImageFile)({
                imageFile,
                maxWidth: 480,
                maxHeight: 500,
                quality: 0.8,
                onCompressSuccess: resolve,
                onCompressError: () => {
                    reject();
                    setUploading(false);
                },
            });
        });
        Promise.all([compressMainImg, compressThumbnailImg])
            .then(compressedImgArr => postMainImage(compressedImgArr))
            .catch(() => { });
    };
    const MainPhotoInput = () => ((0, jsx_runtime_1.jsx)("input", { id: "main_photo_input", name: "file", type: "file", hidden: true, onChange: e => {
            if (e.target.files) {
                uploadMainImage(e.target.files);
            }
        }, onClick: e => {
            (0, webview_app_1.askPhotoPermissionsToWVA)('main_photo_input', e);
            e.currentTarget.value = '';
        } }));
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    if (maxWidth768) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                position: 'relative',
                display: 'flex',
                width: '100%',
                borderBottom: hasNoMainImage ? 0 : '1px solid var(--gray-5)',
                backgroundColor: hasNoMainImage ? '#c4c4c4' : 'unset',
            } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: mainImgSrc, css: {
                        aspectRatio: '207 / 160',
                        width: '100%',
                        objectFit: 'cover',
                        visibility: hasNoMainImage ? 'hidden' : 'visible',
                    } }), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: { position: 'absolute', top: '50%', left: '50%' } }, { children: !uploading && ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label", sx: {
                            columnGap: '8px',
                            left: '-50%',
                            marginTop: '-20px',
                            minWidth: '172px',
                            height: '40px',
                            borderRadius: '100px',
                            fontSize: '16px',
                            color: 'var(--white)',
                            backgroundColor: 'var(--gray-80) !important',
                            backdropFilter: 'blur(5px)',
                        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CameraIconWhiteSvg, { css: { width: '24px', height: '24px' } }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ css: { display: 'flex', alignItems: 'center', columnGap: '2px' } }, { children: [hasNoMainImage ? ((0, jsx_runtime_1.jsx)("span", { children: t('대표이미지 등록') })) : ((0, jsx_runtime_1.jsx)("span", { children: t('대표이미지 변경') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2 error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsx)(MainPhotoInput, {})] }))) }))] })));
    }
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.UpperSectionContentWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '8px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "required_wrapper subtitle2" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "gray-80" }, { children: t('대표 이미지') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-40" }, { children: "1200x928px" }))] })), hasNoMainImage ? ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ component: "label", sx: {
                    flexDirection: 'column',
                    rowGap: '8px',
                    width: '200px',
                    height: '154px',
                    borderRadius: '12px',
                    border: '1px solid var(--gray-10)',
                    color: 'var(--gray-40)',
                    bgcolor: 'var(--surface-bg) !important',
                    fontSize: '14px',
                } }, { children: uploading ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 4 })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CameraIconGraySvg, { css: { width: '32px', height: '32px' } }), (0, jsx_runtime_1.jsx)("span", { children: t('여기를 눌러주세요') }), (0, jsx_runtime_1.jsx)(MainPhotoInput, {})] })) }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'relative',
                    display: 'flex',
                    width: '200px',
                    height: '154px',
                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '12px' }),
                } }, { children: [(0, jsx_runtime_1.jsx)("img", { src: mainImgSrc, css: {
                            width: '100%',
                            height: '100%',
                            borderRadius: '12px',
                            objectFit: 'cover',
                        } }), !uploading && ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ component: "label", sx: {
                            position: 'absolute',
                            top: '12px',
                            right: '12px',
                            columnGap: '8px',
                            height: '32px',
                            p: '0 12px',
                            borderRadius: '100px',
                            fontSize: '16px',
                            color: 'var(--white)',
                            backgroundColor: 'var(--gray-80) !important',
                            backdropFilter: 'blur(5px)',
                        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.CameraIconWhiteSvg, { css: { width: '24px', height: '24px' } }), t('변경'), (0, jsx_runtime_1.jsx)(MainPhotoInput, {})] })))] })))] }));
}
exports.default = default_1;
